import { motion, useReducedMotion } from "framer-motion";

export function Reveal({ children, className = "", delay = 0, y = 28, as = "div" }) {
  const reduce = useReducedMotion();
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={reduce ? { opacity: 0 } : { opacity: 0, y }}
      whileInView={reduce ? { opacity: 1 } : { opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-10% 0px -10% 0px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </MotionTag>
  );
}

// Word-by-word masked reveal for headlines
export function MaskLines({ lines, className = "", startDelay = 0, wordStagger = 0.05 }) {
  const reduce = useReducedMotion();
  let idx = 0;
  return (
    <span className={className}>
      {lines.map((line, li) => (
        <span key={li} className="line-mask">
          <span className="block">
            {line.split(" ").map((word, wi) => {
              const d = startDelay + idx * wordStagger;
              idx += 1;
              return (
                <span key={wi} className="inline-block overflow-hidden align-bottom">
                  <motion.span
                    className="inline-block"
                    initial={reduce ? { opacity: 0 } : { y: "110%" }}
                    animate={reduce ? { opacity: 1 } : { y: 0 }}
                    transition={{ duration: 1, delay: d, ease: [0.22, 1, 0.36, 1] }}
                  >
                    {word}
                    {wi < line.split(" ").length - 1 ? "\u00A0" : ""}
                  </motion.span>
                </span>
              );
            })}
          </span>
        </span>
      ))}
    </span>
  );
}
